import { sortBySequenceNumber } from 'shared/lib/common-util'
import { fromDocumentResponse } from '../../document/models/responseToModel'
import { DocumentCreate } from '../../document/models/request'
import { Document } from '../../document/models/types'
import { toCreateDocumentRequests } from '../models/mapper'
import { createConsignmentItemDocumentsV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function createConsignmentItemDocuments(
  transitOperationId: number,
  consignmentItemId: number,
  documents: DocumentCreate[],
): Promise<Document[]> {
  const requests = toCreateDocumentRequests(documents, transitOperationId, consignmentItemId)
  if (requests.length === 0) {
    return []
  }

  const responses = await createConsignmentItemDocumentsV3(consignmentItemId, requests)

  return responses.map((r, i) => fromDocumentResponse(r, i)).sort(sortBySequenceNumber)
}
